import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Button } from '@progress/kendo-react-buttons';
import { Window } from '@progress/kendo-react-dialogs';
import { Upload } from '@progress/kendo-react-upload';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { EditorUtils } from '@progress/kendo-react-editor';
import { UploadFiletoDirectory } from '../../../../Helpers/DateLakeStorage';

export class InsertImageDialog extends React.Component {

    state = {
        selected: 0,
        files: [],
        organizationId: "",
        projectId: ""
    };

    src = null;
    altText = null;
    title = null;
    width = null;
    height = null;

    onTabSelect = event => this.setState({ selected: event.selected, files: [] });

    onClose = () => this.props.onClose.call(undefined);

    onAddFiles = (event) => {
        this.setState({
            files: event.newState,
            organizationId: this.props.organizationId,
            projectId: this.props.projectId
        })
    }


    onInsert = async (event) => {

        const { view, imageNode } = this.props;
        const { files } = this.state;
        const nodes = view.state.schema.nodes;
        const nodeType = nodes[imageNode];
        const data = {
            src: this.src ? this.src.value : null,
            title: this.title ? this.title.value : null,
            alt: this.altText ? this.altText.value : null,
            width: this.width ? this.width.value : null,
            height: this.height ? this.height.value : null
        };

        const attrs = Object.keys(data)
            .filter(key => data[key] !== null && data[key] !== '')
            .reduce((acc, curr) => Object.assign(acc, { [curr]: data[curr] }), {});

        if (files.length) {
            const data = new FormData();
            let fileName = files[0].name.split('.jpg' || '.png' || '.jpeg' || '.ico')[0] + '_' + new Date().getTime() + files[0].extension
            data.append(`file`, files[0].getRawFile(), fileName)

            let path = this.state.organizationId + "/" + this.state.projectId + "/SchemaImages"
            data.append("path", path)

            const response = await UploadFiletoDirectory(data)

            attrs.src = `${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_CONTAINER}/${this.state.organizationId}/${this.state.projectId}/SchemaImages/${fileName}`

            const newImage = nodeType.createAndFill(attrs);
            EditorUtils.insertNode(view, newImage, true);
            view.focus();
            this.onClose();

        } else {
            const newImage = nodeType.createAndFill(attrs);
            EditorUtils.insertNode(view, newImage, true);
            view.focus();
            this.onClose();
        }
    }

    render() {
        const { view, imageNode } = this.props;
        const state = view && view.state;
        let attrs = {};

        if (state && state.selection.node &&
            state.selection.node.type === state.schema.nodes[imageNode]) {
            attrs = state.selection.node.attrs;
        }

        const fields = (
            <>
                <div className="k-edit-label">
                    <label htmlFor="k-editor-image-alt">
                        Alternate text
                    </label>
                </div>
                <div className="k-edit-field">
                    <input
                        type="text"
                        className="k-textbox"
                        id="k-editor-image-alt"
                        defaultValue={attrs.alt}
                        ref={e => this.altText = e}
                    />
                </div>
                <div className="k-edit-label">
                    <label htmlFor="k-editor-image-title">
                        Title
                    </label>
                </div>
                <div className="k-edit-field">
                    <input
                        type="text"
                        className="k-textbox"
                        id="k-editor-image-title"
                        defaultValue={attrs.title}
                        ref={e => this.title = e}
                    />
                </div>
                <div className="k-edit-label">
                    <label htmlFor="k-editor-image-width">
                        Width (px)
                    </label>
                </div>
                <div className="k-edit-field">
                    <input
                        type="text"
                        className="k-textbox"
                        id="k-editor-image-width"
                        defaultValue={attrs.width}
                        ref={e => this.width = e}
                    />
                </div>
                <div className="k-edit-label">
                    <label htmlFor="k-editor-image-height">
                        Height (px)
                    </label>
                </div>
                <div className="k-edit-field">
                    <input
                        type="text"
                        className="k-textbox"
                        id="k-editor-image-height"
                        defaultValue={attrs.height}
                        ref={e => this.height = e}
                    />
                </div>
            </>
        );

        const buttons = (
            <div className={'text-end'} style={{ clear: 'both' }}>
                <Button onClick={this.onClose}>Cancel</Button>
                <Button onClick={this.onInsert} primary={true}>Insert</Button>
            </div>
        );

        return ReactDOM.createPortal(
            (
                <Window
                    title="Insert Image"
                    onClose={this.onClose}
                    initialWidth={500}
                    initialHeight={480}
                >
                    <TabStrip
                        selected={this.state.selected}
                        onSelect={this.onTabSelect}
                        animation={false}
                    >
                        {Object.entries(attrs).length === 0 && <TabStripTab title="Upload">
                            <div className="k-edit-form-container pt-3 pb-3">
                                <div className="k-edit-label">
                                    <label htmlFor="k-editor-image-width">
                                        Image
                                    </label>
                                </div>
                                <div className="k-edit-field">
                                    <Upload
                                        batch={false}
                                        multiple={false}
                                        defaultFiles={[]}
                                        withCredentials={false}
                                        saveUrl={'https://demos.telerik.com/kendo-ui/service-v4/upload/save'}
                                        removeUrl={'https://demos.telerik.com/kendo-ui/service-v4/upload/remove'}
                                        onAdd={this.onAddFiles}
                                    />
                                </div>
                                {fields}
                                {buttons}
                            </div>
                        </TabStripTab>}
                        <TabStripTab title="By URL">
                            <div className="k-edit-form-container pt-3 pb-3">
                                <div className="k-edit-label">
                                    <label htmlFor="k-editor-image-url">
                                        Web address
                                    </label>
                                </div>
                                <div className="k-edit-field">
                                    <input
                                        type="text"
                                        className="k-textbox"
                                        id="k-editor-image-url"
                                        defaultValue={attrs.src}
                                        disabled={/^data:image/.test(attrs.src || '')}
                                        ref={e => this.src = e}
                                        autoFocus={true}
                                    />
                                </div>
                                {fields}
                                {buttons}
                            </div>
                        </TabStripTab>
                    </TabStrip>
                    <style>
                        {`.k-dropzone { width: 100%; }`}
                    </style>
                </Window>
            ),
            document.body);
    }
}